import { render, staticRenderFns } from "./codeManage.vue?vue&type=template&id=5c3b3530&scoped=true&"
import script from "./codeManage.vue?vue&type=script&lang=js&"
export * from "./codeManage.vue?vue&type=script&lang=js&"
import style0 from "./codeManage.vue?vue&type=style&index=0&id=5c3b3530&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3b3530",
  null
  
)

export default component.exports